module.exports = __webpack_public_path__ + "img/example-rss-payload.9d6b87a6.png";